let mixobj = {
  data(){
    return {
      //路线弹窗
      drawer:false,
      itemClick:[],
      mapclick:{}
    }
  },
  methods: {
    //初始化地图
    initMap() {
      this.map = new AMap.Map('readmeMap', {
        center: [110.79, 32.65],
        resizeEnable: true,
        zoom: 11,
      })
      // 监听地图点击坐标
      this.map.on('click', (e) => {
        this.mapclick = {
          lng: e.lnglat.getLng(),
          lat: e.lnglat.getLat()
        }
      })
      //添加地图控件
      AMap.plugin(['AMap.ToolBar', 'AMap.Scale', 'AMap.moveAnimation'], () => {
        this.map.addControl(new AMap.ToolBar())
        this.map.addControl(new AMap.Scale())
      })
      //获取当前定位(不精准)
      AMap.plugin('AMap.Geolocation', () => {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,//是否使用高精度定位，默认:true
          timeout: 10000,          //超过10秒后停止定位，默认：5s
          buttonPosition: 'RB',    //定位按钮的停靠位置
          buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          // zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
        });
        this.map.addControl(geolocation);
        geolocation.getCurrentPosition(function (status, res) {
          // 获取定位成功回调
          localStorage.setItem("lgtlnt",JSON.stringify(res.position));
        }); //精准定位
      });
    },
  }
}

export default mixobj;



// WEBPACK FOOTER //
// ./src/public/Gmap.js